import { trimBraces } from '../../inboundUtils';
export function activeContactTypeParser(str) {
    return str;
}
export function activeContactTypesParser(str) {
    const activeContactTypesString = trimBraces(str);
    if (!activeContactTypesString) {
        return [];
    }
    return activeContactTypesString.split(',').map(activeContactTypeParser);
}
